<template>
  <div>
    <a-card>
      <a-form-model :form="filterForm" :label-col="{ span: 4 }" :model="filterForm" class="search-form">
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-model-item label="服务">
              <a-select v-model="filterForm.service_ids" show-search mode="multiple" placeholder="按服务筛选" :filter-option="false" @search="handleNameSearch" @change="getWorlflowRelease">
                <a-select-option v-for="service in servicesData" :key="service.service_id" :value="service.service_id">
                  {{ service.service_name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="参与人">
              <user-select v-model="filterForm.users" :project-id="projectId" allow-clear show-search show-all placeholder="按参与人筛选" mode="multiple" @change="getWorlflowRelease" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-form-model-item>
              <a-button v-tc="{ name: '查询' }" type="primary" @click="getWorlflowRelease">查询</a-button>
              <a-button v-tc="{ name: '重置' }" :style="{ margin: '0 12px' }" @click="onReset">重置</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="服务看板" class="service-kanban" size="small">
      <div class="kanban-container">
        <a-card v-for="(env, key) in envItems" :key="key" size="small" class="kanban-status" :bordered="false">
          <span slot="title">
            <span>{{ env.name }}</span>
            <span v-show="!loading">({{ sourceData[env.value].length }})</span>
          </span>
          <a-skeleton v-if="loading" />
          <div v-else>
            <a-card v-for="(record, index) in sourceData[env.value]" :key="index" class="card-items" size="small">
              <span class="card-title"><a-avatar class="service-type" :size="18" :src="serviceTypes[record.service_type].image" />{{ record.service_name }}</span>
              <a-list item-layout="horizontal" :data-source="record.versions" size="small">
                <a-list-item slot="renderItem" slot-scope="version" v-tc="{ name: '点击列表项' }" :class="version.project.id === projectId ? 'verison-item' : 'verison-item verison-item_other'" @click="onDetail(version)">
                  <span class="card-content_version">
                    <a-tooltip v-if="[1, 2].includes(record.service_type) && version.version" placement="top">
                      <span slot="title">{{ `${version.registry_url}/${version.namespace}/${record.service_name}:${version.version}` }}</span>
                      <span>{{ version.version || '-/-' }}</span>
                    </a-tooltip>
                    <span v-else-if="[3, 4].includes(record.service_type)">V{{ version.version || '-/-' }}</span>
                  </span>
                  <span>
                    <span class="card-content_label">质量:</span>
                    <a-tooltip placement="top" :title="version.users ? version.users.map(user => user.nickname).join('; ') : '--'">
                      <span class="card-content_value">{{ version.users.map(user => user.nickname).join('; ') || '--' }}</span>
                    </a-tooltip>
                  </span>
                  <span class="card-content_status">
                    <a-popover>
                      <template slot="content">
                        <h4>流程信息</h4>
                        <div>
                          <span class="card-content_label">所属项目:</span>
                          <span>{{ version.project.name }}</span>
                        </div>
                        <div>
                          <span class="card-content_label">当前阶段:</span>
                          <span>{{ version.step_name }}</span>
                        </div>
                        <div style="min-width: 360px">
                          <span class="card-content_label">流程标题:</span>
                          <span>{{ version.workflow_title }}</span>
                        </div>
                      </template>
                      <a-badge :status="releaseStatus[version.release_status].status" :text="releaseStatus[version.release_status].label" />
                    </a-popover>
                  </span>
                </a-list-item>
              </a-list>
            </a-card>
          </div>
        </a-card>
      </div>
    </a-card>
  </div>
</template>
<script>
import { debounce } from 'lodash';
import { serviceList } from '@/api/system/service';
import { workflowServiceData } from '@/api/project/workflow';
import { serviceTypes, releaseStatus } from '@/utils/dictionary';

import UserSelect from '@/components/User/UserSelect';

export default {
  components: { UserSelect },
  data() {
    return {
      serviceTypes,
      releaseStatus,
      loading: false,
      envItems: [
        {
          value: 'qa',
          name: 'QA环境'
        },
        {
          value: 'demo',
          name: 'Demo环境'
        },
        {
          value: 'prod',
          name: 'Prod环境'
        }
      ],
      sourceData: {
        qa: [],
        demo: [],
        prod: []
      },
      servicesData: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      filterForm: {
        project_id: parseInt(this.$route.params.project_id) || null,
        service_ids: [],
        users: []
      }
    };
  },
  created() {
    this.getServiceList();
    this.getWorlflowRelease();
  },
  methods: {
    getWorlflowRelease() {
      this.loading = true;
      workflowServiceData({ ...this.filterForm, project_id: this.projectId })
        .then(res => {
          this.sourceData = res.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 根据服务名称搜索，增加防抖机制
     */
    handleNameSearch: debounce(function (value) {
      this.getServiceList(value);
    }, 500),

    /**
     * 获取服务列表
     * @param {*} service_name
     */
    getServiceList(service_name = null) {
      serviceList({ name: service_name, page_size: this.$store.getters.pageSize }).then(res => {
        this.servicesData = res.data.services;
      });
    },
    onDetail(version) {
      const link = this.$router.resolve({
        name: 'page:project:workflow:detail',
        params: { project_id: version.project.id },
        query: { workflowId: version.workflow_id }
      });
      window.open(link.href, '_blank');
    },
    onReset() {
      this.filterForm = {
        service_ids: [],
        users: []
      };
      this.getWorlflowRelease();
    }
  }
};
</script>
<style lang="less" scoped>
.service-kanban {
  margin-top: 16px;
}
/deep/.service-kanban > .ant-card-body {
  padding: 4px;
}

.kanban-container {
  display: flex;
  overflow-x: auto;
  background: #fff;
  height: calc(~'100vh - 178px');
}

/deep/.kanban-status > .ant-card-body {
  margin-top: 2px;
  padding: 0;
  overflow-y: auto;
  height: calc(~'100vh - 244px');
}

/deep/.kanban-status {
  flex: 1 0 260px;
  margin: 0 8px;
}
.card-items {
  margin: 8px 0;
  border-radius: 8px;

  .card-name {
    padding-left: 2px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 16px;
    width: 200px;
    display: inline-block;
    word-break: keep-all; /* 不换行 */
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
    text-overflow: ellipsis; /* 当对象内文本溢出时显示省略标记(...) 需与 overflow:hidden;一起使用。*/
  }

  .card-name:hover {
    cursor: pointer;
    color: #3582fb;
  }
}

.card-title {
  font-weight: bold;
  display: block;
  margin-bottom: 8px;
  .service-type {
    margin-right: 4px;
  }
}
/deep/.ant-list-sm .ant-list-item {
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 4px;
  margin-bottom: 1px;
}

.verison-item {
  cursor: pointer;
}
.verison-item:hover {
  position: relative;
  box-shadow: 4px 4px 8px -1px rgba(0, 0, 0, 0.3);
}

.verison-item_other {
  // text-decoration: underline;
  // font-style: italic;
  // background-color: #fcfbfa;
  background-image: radial-gradient(circle, #e5f3ff, #ffffff);
}

.card-content_label {
  font-size: 12px;
  color: #8c95a8;
  margin-right: 4px;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 12px;
}

.card-content_value {
  width: 120px;
  line-height: 12px;
  cursor: pointer;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.card-content_status {
  margin-right: 4px;
}
.card-content_version {
  margin-left: 4px;
}

/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}
</style>
